import { render } from "./ResetResult.vue?vue&type=template&id=37279a00&scoped=true"
import script from "./ResetResult.vue?vue&type=script&lang=js"
export * from "./ResetResult.vue?vue&type=script&lang=js"

import "./ResetResult.vue?vue&type=style&index=0&id=37279a00&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2671924258/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37279a00"]])

export default __exports__